import { useState, useEffect } from "react";
import logo from "./assets/Midgarde_Logo.jpg";


const FORM_ENDPOINT = "https://script.google.com/macros/s/AKfycbyVmB-Q7T48EWInMzYbfWoabUAgAmzk7pAk0PwEhV8cfiNKePkYmKexwpT0BX-6rvCAjA/exec";
const BUDGET_OPTIONS = ["Under R20K","R20K–R50K","R50K–R100K","R100K+","Prefer to discuss"];
const HOW_HEARD_OPTIONS = ["Google Search","LinkedIn","Instagram","Referral","YouTube","Other"];


/* ─── ICONS ─── */
const IconTrend = () => (
 <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C8A96E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
   <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/>
   <polyline points="16 7 22 7 22 13"/>
 </svg>
);
const IconDeal = () => (
 <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C8A96E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
   <path d="M6 9H4.5a2.5 2.5 0 0 0 0 5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 1 0 5H18"/>
   <path d="M8 9h8"/><path d="M8 15h8"/><rect x="6" y="6" width="12" height="12" rx="2"/>
 </svg>
);
const IconFunnel = () => (
 <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C8A96E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
   <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
 </svg>
);
const IconSearch = () => (
 <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C8A96E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
   <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
 </svg>
);
const IconPackage = () => (
 <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C8A96E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
   <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
   <polyline points="3.29 7 12 12 20.71 7"/><line x1="12" y1="22" x2="12" y2="12"/>
 </svg>
);
const IconCheck = () => (
 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C8A96E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
   <polyline points="20 6 9 17 4 12"/>
 </svg>
);
const IconMenu = () => (
 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
   <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
 </svg>
);
const IconClose = () => (
 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
   <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
 </svg>
);
const IconArrow = () => (
 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
   <path d="M5 12h14M12 5l7 7-7 7"/>
 </svg>
);
const IconLinkedIn = () => (
 <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
   <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
   <rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/>
 </svg>
);
const IconInstagram = () => (
 <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
   <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
   <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
   <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
 </svg>
);


/* ─── CREATOR DATA ─── */
const C_SERVICES = [
 { num: "01", icon: <IconTrend />, title: "Content & CTR Optimisation", body: "We analyse your thumbnails, titles, and content structure to increase click-through rates and keep viewers watching longer." },
 { num: "02", icon: <IconDeal />, title: "Brand Deal Sourcing", body: "We identify brands that fit your audience and handle outreach, negotiation, and deal management  you just approve and create." },
 { num: "03", icon: <IconFunnel />, title: "Growth & Funnel Systems", body: "We build systems that convert casual viewers into subscribers, email lists, and community members across every platform." },
];
const C_STEPS = [
 { num: "01", title: "Free Channel Breakdown", body: "Submit your channel and we'll analyse it, identifying your biggest growth opportunities, completely free." },
 { num: "02", title: "Strategy Session", body: "We hop on a call to walk through the findings and agree on a plan that fits your goals and schedule." },
 { num: "03", title: "We Execute", body: "Our team handles the optimisation, outreach, and systems  while you keep creating." },
 { num: "04", title: "Grow Together", body: "We track results, report back, and keep refining. Growth is an ongoing process, not a one-off." },
];
const C_STATS = [
 { num: "2×", label: "Average CTR improvement across managed channels" },
 { num: "80%", label: "Repetitive operations removed from your workflow" },
 { num: "100%", label: "Process-preserving  we work around your creative schedule" },
];


/* ─── BRAND DATA ─── */
const B_SERVICES = [
 { num: "01", icon: <IconSearch />, title: "Creator Sourcing", body: "We identify and vet YouTube creators whose audience matches your brand  by niche, demographics, and engagement quality." },
 { num: "02", icon: <IconDeal />, title: "Deal Negotiation", body: "We handle all outreach and rate negotiation directly with creators or their managers, so you get fair deals without the back-and-forth." },
 { num: "03", icon: <IconPackage />, title: "Campaign Management", body: "From brief delivery to content review to post-campaign reporting, we manage the partnership so you don't have to." },
];
const B_STEPS = [
 { num: "01", title: "Fill Out the Form", body: "Tell us about your brand, your product, and your campaign goals. Takes 3 minutes." },
 { num: "02", title: "Discovery Call", body: "We'll hop on a call to understand your audience, budget, and timeline  and confirm we're the right fit." },
 { num: "03", title: "Creator Matching", body: "We research and present a shortlist of vetted YouTube creators aligned to your brand. You approve." },
 { num: "04", title: "We Execute", body: "Outreach, negotiation, briefing, review, and delivery  all handled by Midgarde." },
];
const B_FIT = [
 "Consumer product or SaaS brand",
 "Monthly marketing budget available for creator deals",
 "Open to education, gaming, finance, or lifestyle YouTube niches",
 "Want a managed service, not just introductions",
];



/* ─── SHARED CSS ─── */
const style = `
 @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@300;400;500&display=swap');


 *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }


 :root {
   --bg:      #0A0A0A;
   --bg2:     #0E0E12;
   --surface: #2A2A35;
   --border:  rgba(255,255,255,0.07);
   --text:    #F5F5F0;
   --muted:   #888890;
   --gold:    #C8A96E;
   --gold-bg: rgba(200,169,110,0.08);
   --gold-bd: rgba(200,169,110,0.25);
 }


 html { scroll-behavior:smooth; }
 body {
   background:var(--bg); color:var(--text);
   font-family:'DM Sans',sans-serif; font-size:16px;
   line-height:1.6; overflow-x:hidden;
   -webkit-font-smoothing:antialiased;
 }


 @keyframes fadeUp  { from{opacity:0;transform:translateY(30px)} to{opacity:1;transform:translateY(0)} }


 .fu { opacity:0; transform:translateY(28px); transition:opacity 0.7s ease, transform 0.7s ease; }
 .fu.vis { opacity:1; transform:translateY(0); }
 .d1{transition-delay:.1s} .d2{transition-delay:.2s}
 .d3{transition-delay:.3s} .d4{transition-delay:.4s} .d5{transition-delay:.5s}
 @media(prefers-reduced-motion:reduce){ .fu{opacity:1;transform:none;transition:none} }


 /* ── NAV ── */
 .nav {
   position:fixed; top:0; left:0; right:0; z-index:50;
   display:flex; align-items:center; justify-content:space-between;
   padding:18px 56px;
   border-bottom:1px solid transparent;
   transition:background .35s, backdrop-filter .35s, border-color .35s;
 }
 .nav.scrolled {
   background:rgba(10,10,10,.88);
   backdrop-filter:blur(18px); -webkit-backdrop-filter:blur(18px);
   border-bottom-color:var(--border);
 }
 .nav-logo {
   height:52px; width:auto; object-fit:contain;
   filter:invert(1);
   display:block;
 }
 .nav-links { display:flex; align-items:center; gap:28px; list-style:none; }
 .nav-links button {
   font-family:'DM Sans',sans-serif; font-size:13px; letter-spacing:.4px;
   color:var(--muted); background:none; border:none; padding:0;
   cursor:pointer; transition:color .2s;
 }
 .nav-links button:hover { color:var(--text); }
 .nav-pill {
   font-family:'DM Sans',sans-serif; font-size:11px; letter-spacing:1px;
   color:var(--gold); background:none; border:1px solid var(--gold-bd);
   padding:7px 16px; cursor:pointer; transition:background .2s, color .2s;
 }
 .nav-pill:hover { background:var(--gold-bg); }
 .nav-right { display:flex; align-items:center; gap:12px; }
 .btn-nav {
   font-family:'DM Sans',sans-serif; font-size:11px; font-weight:500;
   letter-spacing:2px; text-transform:uppercase;
   color:#0A0A0A; background:var(--gold); border:none;
   padding:11px 20px; cursor:pointer; white-space:nowrap; transition:background .2s;
 }
 .btn-nav:hover { background:#d4b87a; }
 .hamburger { display:none; background:none; border:none; color:var(--text); cursor:pointer; padding:4px; }


 /* ── MOBILE NAV ── */
 .mob-nav {
   position:fixed; inset:0; z-index:100; background:var(--bg);
   display:flex; flex-direction:column; align-items:center; justify-content:center; gap:28px;
   transform:translateX(100%); transition:transform .4s ease;
 }
 .mob-nav.open { transform:translateX(0); }
 .mob-close { position:absolute; top:24px; right:24px; background:none; border:none; color:var(--text); cursor:pointer; }
 .mob-link {
   font-family:'Bebas Neue',sans-serif; font-size:38px; letter-spacing:2px;
   color:var(--text); background:none; border:none; padding:0; cursor:pointer; transition:color .2s;
 }
 .mob-link:hover { color:var(--gold); }
 .mob-hr { width:40px; height:1px; background:var(--border); }
 .mob-pill {
   font-family:'DM Sans',sans-serif; font-size:12px; letter-spacing:1px;
   color:var(--gold); background:none; border:1px solid var(--gold-bd);
   padding:10px 24px; cursor:pointer; transition:background .2s;
 }
 .mob-pill:hover { background:var(--gold-bg); }
 .mob-cta {
   font-family:'DM Sans',sans-serif; font-size:11px; font-weight:500;
   letter-spacing:2px; text-transform:uppercase;
   color:#0A0A0A; background:var(--gold); border:none;
   padding:14px 36px; cursor:pointer; margin-top:4px;
 }


 /* ── SECTION COMMONS ── */
 .wrap { max-width:1100px; margin:0 auto; padding:120px 56px; width:100%; }
 .label { display:inline-block; font-size:10px; font-weight:500; letter-spacing:4px; text-transform:uppercase; color:var(--gold); margin-bottom:20px; }
 .h2 { font-family:'Bebas Neue',sans-serif; font-size:clamp(36px,5vw,60px); letter-spacing:2px; color:var(--text); margin-bottom:20px; line-height:1.05; }
 .body-text { font-size:17px; font-weight:300; line-height:1.8; color:var(--muted); }
 .divider { border:none; border-top:1px solid var(--border); }


 /* ── HERO ── */
 .hero { min-height:100vh; display:flex; align-items:center; padding:100px 56px 80px; position:relative; overflow:hidden; }
 .hero-glow { position:absolute; inset:0; pointer-events:none; background:radial-gradient(ellipse at 72% 42%, rgba(200,169,110,.055) 0%, transparent 55%); }
 .hero-geo { position:absolute; top:8%; right:-2%; opacity:.03; pointer-events:none; }
 .hero-inner { max-width:1100px; margin:0 auto; width:100%; position:relative; z-index:2; }


 .eyebrow { display:flex; align-items:center; gap:14px; font-size:10px; font-weight:500; letter-spacing:4px; text-transform:uppercase; color:var(--gold); margin-bottom:24px; animation:fadeUp .6s ease both .1s; }
 .eyebrow::before { content:''; width:36px; height:1px; background:var(--gold); flex-shrink:0; }


 .hero-h1 {
   font-family:'Bebas Neue',sans-serif;
   font-size:clamp(60px,8.5vw,108px);
   letter-spacing:2px; line-height:.96;
   color:var(--text); max-width:820px; margin-bottom:28px;
   animation:fadeUp .7s ease both .25s;
 }
 .hero-h1 .gold { color:var(--gold); }


 .hero-sub { font-size:18px; font-weight:300; line-height:1.75; color:var(--muted); max-width:500px; margin-bottom:48px; animation:fadeUp .7s ease both .4s; }
 .hero-actions { animation:fadeUp .7s ease both .55s; }


 .btn-gold {
   display:inline-flex; align-items:center; gap:10px;
   font-family:'DM Sans',sans-serif; font-size:12px; font-weight:500;
   letter-spacing:2.5px; text-transform:uppercase;
   color:#0A0A0A; background:var(--gold); border:2px solid var(--gold);
   padding:17px 40px; cursor:pointer; transition:background .25s, color .25s;
 }
 .btn-gold:hover { background:transparent; color:var(--gold); }
 .hero-trust { margin-top:20px; font-size:12px; letter-spacing:1.5px; color:var(--muted); opacity:.5; }


 /* ── SERVICES ── */
 .services-grid { display:grid; grid-template-columns:repeat(3,1fr); border:1px solid var(--border); margin-top:52px; }
 .svc-card { background:var(--bg); padding:44px 36px; border-right:1px solid var(--border); position:relative; cursor:default; transition:background .3s; }
 .svc-card:last-child { border-right:none; }
 .svc-card::before { content:''; position:absolute; top:0; left:0; right:0; height:2px; background:var(--gold); transform:scaleX(0); transform-origin:left; transition:transform .4s ease; }
 .svc-card:hover { background:var(--gold-bg); }
 .svc-card:hover::before { transform:scaleX(1); }
 .svc-num { font-size:10px; letter-spacing:3px; color:var(--gold); opacity:.5; margin-bottom:24px; }
 .svc-icon { margin-bottom:20px; }
 .svc-title { font-family:'Bebas Neue',sans-serif; font-size:24px; letter-spacing:1.5px; color:var(--text); margin-bottom:14px; }
 .svc-body { font-size:14px; font-weight:300; color:var(--muted); line-height:1.75; }


 /* ── PROCESS ── */
 .process-steps { display:grid; grid-template-columns:repeat(4,1fr); margin-top:60px; gap:0; position:relative; }
 .process-steps::before { content:''; position:absolute; top:24px; left:12.5%; right:12.5%; height:1px; background:var(--gold); opacity:.2; }
 .step { padding:0 24px; }
 .step-num { font-family:'Bebas Neue',sans-serif; font-size:52px; letter-spacing:2px; color:var(--gold); opacity:.15; line-height:1; margin-bottom:16px; }
 .step-title { font-family:'Bebas Neue',sans-serif; font-size:20px; letter-spacing:1.5px; color:var(--text); margin-bottom:10px; }
 .step-body { font-size:14px; font-weight:300; color:var(--muted); line-height:1.7; }


 /* ── REACH BANNER ── */
 .reach-banner { text-align:center; padding:80px 24px; background:var(--bg2); }
 .reach-label { font-size:10px; font-weight:500; letter-spacing:4px; text-transform:uppercase; color:var(--gold); opacity:.7; display:block; margin-bottom:24px; }
 .reach-num { font-family:'Bebas Neue',sans-serif; font-size:clamp(80px,12vw,128px); letter-spacing:2px; color:var(--gold); line-height:1; margin-bottom:18px; }
 .reach-body { font-size:16px; font-weight:300; color:var(--muted); max-width:460px; margin:0 auto; line-height:1.8; }


 /* ── STATS ── */
 .stats-grid { display:grid; grid-template-columns:repeat(3,1fr); border-top:1px solid var(--border); }
 .stat-item { padding:48px 40px; border-right:1px solid var(--border); text-align:center; }
 .stat-item:last-child { border-right:none; }
 .stat-num { font-family:'Bebas Neue',sans-serif; font-size:clamp(44px,5vw,64px); letter-spacing:2px; color:var(--gold); line-height:1; margin-bottom:10px; }
 .stat-label { font-size:13px; color:var(--muted); line-height:1.5; }


 /* ── CHALLENGE ── */
 .dark-bg { background:var(--bg2); }
 .challenge-inner { max-width:720px; margin:0 auto; padding:120px 56px; text-align:center; }
 .pain-row { display:flex; justify-content:center; gap:48px; margin:36px 0 44px; }
 .pain-item { display:flex; flex-direction:column; align-items:center; gap:10px; font-size:10px; letter-spacing:2px; text-transform:uppercase; color:var(--muted); max-width:80px; text-align:center; line-height:1.4; }
 .challenge-body { font-size:18px; font-weight:300; line-height:1.85; color:var(--muted); }
 .challenge-body p+p { margin-top:18px; }
 .hl { color:var(--text); font-weight:400; }


 /* ── WHO WE WORK WITH ── */
 .who-grid { display:grid; grid-template-columns:1fr 1fr; gap:60px; margin-top:44px; align-items:start; }
 .who-body { font-size:17px; font-weight:300; line-height:1.8; color:var(--muted); }
 .who-body p+p { margin-top:16px; }
 .fit-list { display:flex; flex-direction:column; gap:14px; }
 .fit-item { display:flex; align-items:flex-start; gap:12px; font-size:15px; font-weight:300; color:var(--text); line-height:1.5; }
 .fit-icon { flex-shrink:0; margin-top:3px; }


 /* ── PROOF ── */
 .proof-quote-wrap { max-width:640px; margin:0 auto; text-align:center; padding-bottom:56px; }
 .qmark { font-size:72px; color:var(--gold); opacity:.25; line-height:.7; margin-bottom:24px; display:block; }
 .qtext { font-size:clamp(17px,2.2vw,22px); font-style:italic; color:var(--text); line-height:1.65; margin-bottom:16px; }
 .qsub { font-size:13px; color:var(--muted); letter-spacing:.5px; }


 /* ── CONTACT ── */
 .contact-grid { display:grid; grid-template-columns:1fr 1.35fr; gap:72px; align-items:start; }
 .contact-detail { display:flex; align-items:center; gap:10px; font-size:13px; color:var(--muted); margin-top:28px; }
 .contact-detail::before { content:''; width:20px; height:1px; background:var(--gold); flex-shrink:0; }
 .form-grid { display:grid; grid-template-columns:1fr 1fr; gap:14px; }
 .ff { display:flex; flex-direction:column; gap:7px; }
 .ff.full { grid-column:1/-1; }
 .fl { font-size:10px; font-weight:500; letter-spacing:2px; text-transform:uppercase; color:var(--muted); }
 .fi {
   background:#0f0f18; border:1px solid var(--border); color:var(--text);
   padding:13px 15px; font-size:15px; font-family:'DM Sans',sans-serif; font-weight:300;
   outline:none; width:100%; border-radius:0; appearance:none;
   transition:border-color .2s, box-shadow .2s;
 }
 .fi:focus { border-color:var(--gold); box-shadow:0 0 0 2px rgba(200,169,110,.1); }
 .fi::placeholder { color:#3a3a4a; }
 select.fi {
   cursor:pointer;
   background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%23888890' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E");
   background-repeat:no-repeat; background-position:right 13px center; padding-right:36px;
 }
 select.fi option { background:#0A0A0A; }
 .hp { display:none !important; position:absolute; left:-9999px; }
 .btn-submit {
   grid-column:1/-1; width:100%;
   display:flex; align-items:center; justify-content:center; gap:10px;
   font-family:'DM Sans',sans-serif; font-size:12px; font-weight:500;
   letter-spacing:2.5px; text-transform:uppercase;
   color:#0A0A0A; background:var(--gold); border:2px solid var(--gold);
   padding:18px; cursor:pointer; margin-top:6px; transition:background .25s, color .25s;
 }
 .btn-submit:hover:not(:disabled) { background:transparent; color:var(--gold); }
 .btn-submit:disabled { opacity:.45; cursor:not-allowed; }
 .form-err { grid-column:1/-1; font-size:13px; color:#e06060; text-align:center; padding:6px 0; }
 .form-success { display:flex; flex-direction:column; align-items:center; text-align:center; padding:56px 24px; }
 .success-ring { width:60px; height:60px; border-radius:50%; background:var(--gold-bg); border:1px solid var(--gold-bd); display:flex; align-items:center; justify-content:center; margin-bottom:24px; }
 .success-title { font-family:'Bebas Neue',sans-serif; font-size:42px; letter-spacing:2px; color:var(--text); margin-bottom:12px; }
 .success-body { font-size:15px; color:var(--muted); line-height:1.65; }


 /* ── FOOTER ── */
 .footer { border-top:1px solid var(--border); background:var(--bg); }
 .footer-grid { max-width:1100px; margin:0 auto; padding:64px 56px 40px; display:grid; grid-template-columns:1.6fr 1fr 1fr; gap:48px; }
 .footer-logo { height:44px; width:auto; object-fit:contain; filter:invert(1); opacity:.8; margin-bottom:14px; display:block; }
 .footer-desc { font-size:14px; color:var(--muted); line-height:1.65; margin-bottom:8px; }
 .footer-loc { font-size:11px; letter-spacing:1.5px; text-transform:uppercase; color:var(--muted); opacity:.5; }
 .footer-col-title { font-family:'Bebas Neue',sans-serif; font-size:14px; letter-spacing:3px; color:var(--gold); margin-bottom:18px; }
 .footer-links { list-style:none; display:flex; flex-direction:column; gap:11px; }
 .footer-links button { font-size:14px; color:var(--muted); background:none; border:none; padding:0; font-family:'DM Sans',sans-serif; cursor:pointer; transition:color .2s; }
 .footer-links button:hover { color:var(--text); }
 .socials { display:flex; gap:12px; }
 .social-btn { width:40px; height:40px; border:1px solid var(--border); display:flex; align-items:center; justify-content:center; color:var(--muted); text-decoration:none; transition:border-color .2s, color .2s; }
 .social-btn:hover { border-color:var(--gold); color:var(--gold); }
 .footer-bar { max-width:1100px; margin:0 auto; padding:20px 56px; border-top:1px solid var(--border); font-size:11px; color:var(--muted); opacity:.5; }


 /* ── RESPONSIVE ── */
 @media(max-width:900px){
   .nav { padding:16px 24px; }
   .nav-links, .nav-pill, .btn-nav { display:none; }
   .hamburger { display:flex; }
   .hero { padding:90px 24px 64px; }
   .challenge-inner { padding:80px 24px; }
   .pain-row { gap:24px; }
   .wrap { padding:80px 24px; }
   .services-grid { grid-template-columns:1fr; }
   .svc-card { border-right:none; border-bottom:1px solid var(--border); }
   .svc-card:last-child { border-bottom:none; }
   .process-steps { grid-template-columns:1fr 1fr; gap:40px; }
   .process-steps::before { display:none; }
   .step { padding:0; }
   .who-grid { grid-template-columns:1fr; gap:36px; }
   .stats-grid { grid-template-columns:1fr; }
   .stat-item { border-right:none; border-bottom:1px solid var(--border); }
   .stat-item:last-child { border-bottom:none; }
   .contact-grid { grid-template-columns:1fr; gap:48px; }
   .form-grid { grid-template-columns:1fr; }
   .footer-grid { grid-template-columns:1fr; gap:36px; padding:48px 24px 32px; }
   .footer-bar { padding:18px 24px; }
 }
 @media(max-width:480px){
   .hero-h1 { font-size:clamp(52px,13vw,80px); }
   .process-steps { grid-template-columns:1fr; }
 }
`;


/* ─── SHARED FOOTER ─── */
function Footer({ go }) {
 return (
   <footer className="footer">
     <div className="footer-grid">
       <div>
         <img src={logo} alt="Midgarde Media" className="footer-logo" />
         <p className="footer-desc">Boutique YouTube creator growth and brand partnerships agency.</p>
       </div>
       <div>
         <p className="footer-col-title">Quick Links</p>
         <ul className="footer-links">
           <li><button onClick={() => go('services')}>Services</button></li>
           <li><button onClick={() => go('process')}>Process</button></li>
           <li><button onClick={() => go('contact')}>Contact</button></li>
         </ul>
       </div>
       <div>
         <p className="footer-col-title">Follow Us</p>
         <div className="socials">
           <a href="https://linkedin.com/company/midgarde-media" target="_blank" rel="noopener noreferrer" className="social-btn" aria-label="LinkedIn"><IconLinkedIn /></a>
           <a href="https://instagram.com/midgardemedia" target="_blank" rel="noopener noreferrer" className="social-btn" aria-label="Instagram"><IconInstagram /></a>
         </div>
       </div>
     </div>
     <div className="footer-bar">© Midgarde Media Pty Ltd · All rights reserved</div>
   </footer>
 );
}


/* ══════════════════════════════════════════
  CREATOR PAGE    main landing  /
══════════════════════════════════════════ */
function CreatorPage({ navigate }) {
 const [scrolled, setScrolled] = useState(false);
 const [mobOpen, setMobOpen]   = useState(false);
 const [status, setStatus]     = useState('idle');
 const [form, setForm]         = useState({ name:'', email:'', channel:'', hp:'' });


 useEffect(() => {
   const fn = () => setScrolled(window.scrollY > 50);
   window.addEventListener('scroll', fn, { passive:true });
   return () => window.removeEventListener('scroll', fn);
 }, []);


 useEffect(() => {
   const obs = new IntersectionObserver(
     entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('vis'); }),
     { threshold: 0.1 }
   );
   document.querySelectorAll('.fu').forEach(el => obs.observe(el));
   return () => obs.disconnect();
 }, []);


 useEffect(() => {
   document.body.style.overflow = mobOpen ? 'hidden' : '';
   return () => { document.body.style.overflow = ''; };
 }, [mobOpen]);


 const go = (id) => {
   const wasOpen = mobOpen;
   setMobOpen(false);
   setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior:'smooth' }), wasOpen ? 380 : 0);
 };


 const setField = e => setForm(p => ({ ...p, [e.target.name]: e.target.value }));


 const submit = async (e) => {
   e.preventDefault();
   if (form.hp) return;
   setStatus('submitting');
   try {
     await fetch(FORM_ENDPOINT, {
       method: 'POST',
       body: JSON.stringify({ name: form.name, email: form.email, channel: form.channel, source: 'creator' }),
     });
     setStatus('success');
   } catch { setStatus('error'); }
 };


 return (
   <>
     <style>{style}</style>


     {/* Mobile nav */}
     <div className={`mob-nav${mobOpen ? ' open' : ''}`} role="dialog" aria-modal="true" aria-label="Navigation">
       <button className="mob-close" onClick={() => setMobOpen(false)} aria-label="Close menu"><IconClose /></button>
       <button className="mob-link" onClick={() => go('services')}>Services</button>
       <button className="mob-link" onClick={() => go('process')}>How It Works</button>
       <button className="mob-link" onClick={() => go('contact')}>Contact</button>
       <div className="mob-hr" />
       <button className="mob-pill" onClick={() => navigate('brands')}>For Brands →</button>
       <button className="mob-cta" onClick={() => go('contact')}>Get Started</button>
     </div>


     {/* Nav */}
     <nav className={`nav${scrolled ? ' scrolled' : ''}`}>
       <img src={logo} alt="Midgarde Media" className="nav-logo" />
       <ul className="nav-links">
         <li><button onClick={() => go('services')}>Services</button></li>
         <li><button onClick={() => go('process')}>How It Works</button></li>
         <li><button onClick={() => go('contact')}>Contact</button></li>
       </ul>
       <div className="nav-right">
         <button className="nav-pill" onClick={() => navigate('brands')}>For Brands →</button>
         <button className="btn-nav" onClick={() => go('contact')}>Get Started</button>
         <button className="hamburger" onClick={() => setMobOpen(true)} aria-label="Open menu"><IconMenu /></button>
       </div>
     </nav>


     {/* ── HERO ── */}
     <section id="hero" className="hero">
       <div className="hero-glow" />
       <svg className="hero-geo" width="480" height="480" viewBox="0 0 480 480" fill="none">
         <circle cx="240" cy="240" r="220" stroke="#C8A96E" strokeWidth=".8"/>
         <circle cx="240" cy="240" r="160" stroke="#C8A96E" strokeWidth=".5"/>
         <circle cx="240" cy="240" r="100" stroke="#C8A96E" strokeWidth=".5"/>
         <line x1="20" y1="240" x2="460" y2="240" stroke="#C8A96E" strokeWidth=".5"/>
         <line x1="240" y1="20" x2="240" y2="460" stroke="#C8A96E" strokeWidth=".5"/>
         <line x1="84" y1="84" x2="396" y2="396" stroke="#C8A96E" strokeWidth=".3"/>
         <line x1="396" y1="84" x2="84" y2="396" stroke="#C8A96E" strokeWidth=".3"/>
       </svg>
       <div className="hero-inner">
         <p className="eyebrow">YouTube Creator Management </p>
         <h1 className="hero-h1">
           We Turn Your<br />Channel Into<br /><span className="gold">A Career.</span>
         </h1>
         <p className="hero-sub">
           From CTR optimisation to landing brand deals  Midgarde Media handles the business side so you can focus on creating.
         </p>
         <div className="hero-actions">
           <button className="btn-gold" onClick={() => go('contact')}>
             Get a Free Channel Breakdown <IconArrow />
           </button>
           <p className="hero-trust">Working with creators from 100K to 4M+ subscribers</p>
         </div>
       </div>
     </section>


     <hr className="divider" />


     {/* ── SERVICES ── */}
     <section id="services">
       <div className="wrap">
         <span className="label fu">What We Do</span>
         <h2 className="h2 fu d1">Everything except the filming.</h2>
         <p className="body-text fu d2" style={{maxWidth:560}}>
           We handle the strategy, systems, and deals so your channel grows without changing what makes it yours.
         </p>
         <div className="services-grid">
           {C_SERVICES.map((s,i) => (
             <div className={`svc-card fu d${i+2}`} key={i}>
               <p className="svc-num">{s.num}</p>
               <div className="svc-icon">{s.icon}</div>
               <p className="svc-title">{s.title}</p>
               <p className="svc-body">{s.body}</p>
             </div>
           ))}
         </div>
       </div>
     </section>


     <hr className="divider" />


     {/* ── PROCESS ── */}
     <section id="process" className="dark-bg">
       <div className="wrap">
         <span className="label fu">The Process</span>
         <h2 className="h2 fu d1">Simple to start. Results from there.</h2>
         <div className="process-steps">
           {C_STEPS.map((s,i) => (
             <div className={`step fu d${i+1}`} key={i}>
               <div className="step-num">{s.num}</div>
               <p className="step-title">{s.title}</p>
               <p className="step-body">{s.body}</p>
             </div>
           ))}
         </div>
       </div>
     </section>


     <hr className="divider" />


     {/* ── REACH BANNER ── */}
     <div className="reach-banner">
       <span className="reach-label">Combined Reach</span>
       <div className="reach-num fu">5M+</div>
       <p className="reach-body fu d1">Subscribers under management across our network of YouTube channels and growing.</p>
     </div>


     {/* ── STATS ── */}
     <div className="stats-grid">
       {C_STATS.map((s,i) => (
         <div className={`stat-item fu d${i+1}`} key={i}>
           <div className="stat-num">{s.num}</div>
           <p className="stat-label">{s.label}</p>
         </div>
       ))}
     </div>


     <hr className="divider" />


     {/* ── CONTACT ── */}
     <section id="contact">
       <div className="wrap">
         <div className="contact-grid">
           <div>
             <span className="label fu">Let's Work Together</span>
             <h2 className="h2 fu d1">Tell us about your channel.</h2>
             <p className="body-text fu d2" style={{maxWidth:380}}>
               Drop your details, and we'll send you a personalised channel breakdown completely free, no commitment.
             </p>
             <p className="contact-detail fu d3">Response within 48 hours</p>
           </div>
           <div className="fu d2">
             {status === 'success' ? (
               <div className="form-success">
                 <div className="success-ring"><IconCheck /></div>
                 <p className="success-title">Request Sent</p>
                 <p className="success-body">We'll review your channel and send your free breakdown within 48 hours.</p>
               </div>
             ) : (
               <form onSubmit={submit}>
                 <div className="form-grid">
                   <div className="hp" aria-hidden="true">
                     <input type="text" name="hp" value={form.hp} onChange={setField} tabIndex="-1" autoComplete="off" />
                   </div>
                   <div className="ff full">
                     <label htmlFor="c-name" className="fl">Your Name *</label>
                     <input id="c-name" name="name" type="text" className="fi" placeholder="Jane Creator" required value={form.name} onChange={setField} />
                   </div>
                   <div className="ff full">
                     <label htmlFor="c-email" className="fl">Email Address *</label>
                     <input id="c-email" name="email" type="email" className="fi" placeholder="jane@youremail.com" required value={form.email} onChange={setField} />
                   </div>
                   <div className="ff full">
                     <label htmlFor="c-channel" className="fl">Channel / Profile URL *</label>
                     <input id="c-channel" name="channel" type="text" className="fi" placeholder="youtube.com/@yourchannel" required value={form.channel} onChange={setField} />
                   </div>
                   <button type="submit" className="btn-submit" disabled={status === 'submitting'}>
                     {status === 'submitting' ? 'Sending…' : <>Send My Breakdown Request <IconArrow /></>}
                   </button>
                   {status === 'error' && <p className="form-err">Something went wrong. Please try again or email us directly.</p>}
                 </div>
               </form>
             )}
           </div>
         </div>
       </div>
     </section>


     <Footer go={go} />
   </>
 );
}


/* ══════════════════════════════════════════
  BRAND PAGE    /brands
══════════════════════════════════════════ */
function BrandPage({ navigate }) {
 const [scrolled, setScrolled] = useState(false);
 const [mobOpen, setMobOpen]   = useState(false);
 const [status, setStatus]     = useState('idle');
 const [form, setForm]         = useState({
   brandName:'', yourName:'', email:'', website:'',
   product:'', budget:'', howHeard:'', hp:'',
 });


 useEffect(() => {
   const fn = () => setScrolled(window.scrollY > 50);
   window.addEventListener('scroll', fn, { passive:true });
   return () => window.removeEventListener('scroll', fn);
 }, []);


 useEffect(() => {
   const obs = new IntersectionObserver(
     entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('vis'); }),
     { threshold: 0.1 }
   );
   document.querySelectorAll('.fu').forEach(el => obs.observe(el));
   return () => obs.disconnect();
 }, []);


 useEffect(() => {
   document.body.style.overflow = mobOpen ? 'hidden' : '';
   return () => { document.body.style.overflow = ''; };
 }, [mobOpen]);


 const go = (id) => {
   const wasOpen = mobOpen;
   setMobOpen(false);
   setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior:'smooth' }), wasOpen ? 380 : 0);
 };


 const setField = e => setForm(p => ({ ...p, [e.target.name]: e.target.value }));


 const submit = async (e) => {
   e.preventDefault();
   if (form.hp) return;
   setStatus('submitting');
   try {
     await fetch(FORM_ENDPOINT, {
       method: 'POST',
       body: JSON.stringify({
         brand_name: form.brandName, your_name: form.yourName,
         email: form.email, website: form.website,
         product: form.product, budget: form.budget,
         how_heard: form.howHeard, source: 'brand',
       }),
     });
     setStatus('success');
   } catch { setStatus('error'); }
 };


 return (
   <>
     <style>{style}</style>


     {/* Mobile nav */}
     <div className={`mob-nav${mobOpen ? ' open' : ''}`} role="dialog" aria-modal="true" aria-label="Navigation">
       <button className="mob-close" onClick={() => setMobOpen(false)} aria-label="Close menu"><IconClose /></button>
       <button className="mob-link" onClick={() => go('b-services')}>Services</button>
       <button className="mob-link" onClick={() => go('b-process')}>How It Works</button>
       <button className="mob-link" onClick={() => go('b-who')}>Who We Work With</button>
       <button className="mob-link" onClick={() => go('b-contact')}>Contact</button>
       <div className="mob-hr" />
       <button className="mob-pill" onClick={() => navigate('creator')}>← For Creators</button>
       <button className="mob-cta" onClick={() => go('b-contact')}>Work With Us</button>
     </div>


     {/* Nav */}
     <nav className={`nav${scrolled ? ' scrolled' : ''}`}>
       <img src={logo} alt="Midgarde Media" className="nav-logo" />
       <ul className="nav-links">
         <li><button onClick={() => go('b-services')}>Services</button></li>
         <li><button onClick={() => go('b-process')}>How It Works</button></li>
         <li><button onClick={() => go('b-who')}>Who We Work With</button></li>
         <li><button onClick={() => go('b-contact')}>Contact</button></li>
       </ul>
       <div className="nav-right">
         <button className="nav-pill" onClick={() => navigate('creator')}>← For Creators</button>
         <button className="btn-nav" onClick={() => go('b-contact')}>Work With Us</button>
         <button className="hamburger" onClick={() => setMobOpen(true)} aria-label="Open menu"><IconMenu /></button>
       </div>
     </nav>


     {/* ── HERO ── */}
     <section id="b-hero" className="hero">
       <div className="hero-glow" />
       <svg className="hero-geo" width="480" height="480" viewBox="0 0 480 480" fill="none">
         <circle cx="240" cy="240" r="220" stroke="#C8A96E" strokeWidth=".8"/>
         <circle cx="240" cy="240" r="160" stroke="#C8A96E" strokeWidth=".5"/>
         <circle cx="240" cy="240" r="100" stroke="#C8A96E" strokeWidth=".5"/>
         <line x1="20" y1="240" x2="460" y2="240" stroke="#C8A96E" strokeWidth=".5"/>
         <line x1="240" y1="20" x2="240" y2="460" stroke="#C8A96E" strokeWidth=".5"/>
         <line x1="84" y1="84" x2="396" y2="396" stroke="#C8A96E" strokeWidth=".3"/>
         <line x1="396" y1="84" x2="84" y2="396" stroke="#C8A96E" strokeWidth=".3"/>
       </svg>
       <div className="hero-inner">
         <p className="eyebrow">YouTube Brand Partnerships</p>
         <h1 className="hero-h1">
           YouTube<br />Sponsorships.<br /><span className="gold">Done For You.</span>
         </h1>
         <p className="hero-sub">
           Midgarde Media connects brands with the right YouTube creators and handles everything from outreach to campaign delivery.
         </p>
         <div className="hero-actions">
           <button className="btn-gold" onClick={() => go('b-contact')}>
             Get In Touch <IconArrow />
           </button>
           <p className="hero-trust">Boutique agency · YouTube specialists .</p>
         </div>
       </div>
     </section>


     <hr className="divider" />


     {/* ── CHALLENGE ── */}
     <section id="b-challenge" className="dark-bg">
       <div className="challenge-inner">
         <span className="label fu">The Challenge</span>
         <h2 className="h2 fu d1">Most brands never crack YouTube sponsorships.</h2>
         <div className="pain-row fu d2">
           {[
             { label:"Finding creators", icon:<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#C8A96E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity=".7"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg> },
             { label:"Cold outreach",    icon:<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#C8A96E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity=".7"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg> },
             { label:"Rate confusion",  icon:<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#C8A96E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity=".7"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg> },
           ].map((p,i) => <div className="pain-item" key={i}>{p.icon}<span>{p.label}</span></div>)}
         </div>
         <div className="challenge-body fu d3">
           <p><span className="hl">Finding the right creators</span> takes weeks of research. Outreach goes unanswered. Rates are all over the place. And when a campaign finally goes live, it underperforms.</p>
           <p>It's not the channel's fault  <span className="hl">it's the process.</span> And most brands don't have the infrastructure to run it properly.</p>
         </div>
       </div>
     </section>


     <hr className="divider" />


     {/* ── SERVICES ── */}
     <section id="b-services">
       <div className="wrap">
         <span className="label fu">What We Do</span>
         <h2 className="h2 fu d1">We run your YouTube sponsorships end to end.</h2>
         <p className="body-text fu d2" style={{maxWidth:580}}>
           Midgarde Media is a boutique agency that manages the full creator partnership process for brands. You brief us on your goals. We handle the rest.
         </p>
         <div className="services-grid">
           {B_SERVICES.map((s,i) => (
             <div className={`svc-card fu d${i+2}`} key={i}>
               <p className="svc-num">{s.num}</p>
               <div className="svc-icon">{s.icon}</div>
               <p className="svc-title">{s.title}</p>
               <p className="svc-body">{s.body}</p>
             </div>
           ))}
         </div>
       </div>
     </section>


     <hr className="divider" />


     {/* ── PROCESS ── */}
     <section id="b-process" className="dark-bg">
       <div className="wrap">
         <span className="label fu">The Process</span>
         <h2 className="h2 fu d1">Simple to start. Fully managed from there.</h2>
         <div className="process-steps">
           {B_STEPS.map((s,i) => (
             <div className={`step fu d${i+1}`} key={i}>
               <div className="step-num">{s.num}</div>
               <p className="step-title">{s.title}</p>
               <p className="step-body">{s.body}</p>
             </div>
           ))}
         </div>
       </div>
     </section>


     <hr className="divider" />


     {/* ── WHO WE WORK WITH ── */}
     <section id="b-who">
       <div className="wrap">
         <span className="label fu">Who We Work With</span>
         <h2 className="h2 fu d1">Built for brands that take YouTube seriously.</h2>
         <div className="who-grid">
           <div className="who-body fu d2">
             <p>We work best with brands that have a clear product, a real audience fit on YouTube, and a willingness to let the process work.</p>
             <p>We're not the right fit for everyone  and that's by design.</p>
           </div>
           <div className="fit-list">
             {B_FIT.map((item,i) => (
               <div className={`fit-item fu d${i+2}`} key={i}>
                 <span className="fit-icon"><IconCheck /></span>
                 <span>{item}</span>
               </div>
             ))}
           </div>
         </div>
       </div>
     </section>


     <hr className="divider" />




     {/* ── CONTACT ── */}
     <section id="b-contact">
       <div className="wrap">
         <div className="contact-grid">
           <div>
             <span className="label fu">Let's Work Together</span>
             <h2 className="h2 fu d1">Tell us about your brand.</h2>
             <p className="body-text fu d2" style={{maxWidth:400}}>
               Fill out the form and we'll get back to you within 24 hours to explore whether Midgarde is the right fit for your next campaign.
             </p>
             <p className="contact-detail fu d3">Response within 24 hours</p>
           </div>
           <div className="fu d2">
             {status === 'success' ? (
               <div className="form-success">
                 <div className="success-ring"><IconCheck /></div>
                 <p className="success-title">Enquiry Sent</p>
                 <p className="success-body">We'll review your submission and get back to you within 24 hours.</p>
               </div>
             ) : (
               <form onSubmit={submit}>
                 <div className="form-grid">
                   <div className="hp" aria-hidden="true">
                     <input type="text" name="hp" value={form.hp} onChange={setField} tabIndex="-1" autoComplete="off" />
                   </div>
                   <div className="ff">
                     <label htmlFor="b-brand" className="fl">Brand / Company Name *</label>
                     <input id="b-brand" name="brandName" type="text" className="fi" placeholder="Acme Corp" required value={form.brandName} onChange={setField} />
                   </div>
                   <div className="ff">
                     <label htmlFor="b-name" className="fl">Your Name *</label>
                     <input id="b-name" name="yourName" type="text" className="fi" placeholder="Jane Smith" required value={form.yourName} onChange={setField} />
                   </div>
                   <div className="ff">
                     <label htmlFor="b-email" className="fl">Your Email *</label>
                     <input id="b-email" name="email" type="email" className="fi" placeholder="jane@acme.com" required value={form.email} onChange={setField} />
                   </div>
                   <div className="ff">
                     <label htmlFor="b-website" className="fl">Website or Social Link</label>
                     <input id="b-website" name="website" type="text" className="fi" placeholder="acme.com or @acme" value={form.website} onChange={setField} />
                   </div>
                   <div className="ff full">
                     <label htmlFor="b-product" className="fl">What are you looking to promote? *</label>
                     <input id="b-product" name="product" type="text" className="fi" placeholder="Brief description of your product or service" required value={form.product} onChange={setField} />
                   </div>
                   <div className="ff">
                     <label htmlFor="b-budget" className="fl">Monthly Budget *</label>
                     <select id="b-budget" name="budget" className="fi" required value={form.budget} onChange={setField}>
                       <option value="">Select range…</option>
                       {BUDGET_OPTIONS.map(o => <option key={o} value={o}>{o}</option>)}
                     </select>
                   </div>
                   <div className="ff">
                     <label htmlFor="b-heard" className="fl">How did you hear about us?</label>
                     <select id="b-heard" name="howHeard" className="fi" value={form.howHeard} onChange={setField}>
                       <option value="">Select…</option>
                       {HOW_HEARD_OPTIONS.map(o => <option key={o} value={o}>{o}</option>)}
                     </select>
                   </div>
                   <button type="submit" className="btn-submit" disabled={status === 'submitting'}>
                     {status === 'submitting' ? 'Sending…' : <>Send Enquiry <IconArrow /></>}
                   </button>
                   {status === 'error' && <p className="form-err">Something went wrong. Please try again or email us directly.</p>}
                 </div>
               </form>
             )}
           </div>
         </div>
       </div>
     </section>


     <Footer go={go} />
   </>
 );
}


/* ══════════════════════════════════════════
  APP  client-side router
══════════════════════════════════════════ */
export default function App() {
 const [page, setPage] = useState(() =>
   window.location.pathname.startsWith('/brands') ? 'brands' : 'creator'
 );


 const navigate = (p) => {
   window.history.pushState({}, '', p === 'brands' ? '/brands' : '/');
   setPage(p);
   window.scrollTo({ top: 0 });
 };


 useEffect(() => {
   const onPop = () =>
     setPage(window.location.pathname.startsWith('/brands') ? 'brands' : 'creator');
   window.addEventListener('popstate', onPop);
   return () => window.removeEventListener('popstate', onPop);
 }, []);


 return page === 'brands'
   ? <BrandPage navigate={navigate} />
   : <CreatorPage navigate={navigate} />;
}